import { UUID } from './uuid';
export class Ad {
  public id: UUID;
  public name: string;
  public is_active: boolean;
  public ad_text: string;
  public location: string;
}
